import { Fab, useMediaQuery, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const PageFAB = ({ onClick, label }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!isMobile) return null;

  return (
    <Fab
      color="primary"
      aria-label={label}
      onClick={onClick}
      sx={{ position: "fixed", bottom: 72, right: 16 }}
    >
      <AddIcon />
    </Fab>
  );
};

export default PageFAB;
